import {Ventrata} from 'types'

export const getCurrency = (obj: Ventrata.Order | Ventrata.Booking) => {
  const currency = obj.pricing?.currency

  if (!currency) {
    throw new Error('Currency is not defined')
  }

  return currency
}
